// extracted by mini-css-extract-plugin
export default {"container":"LinkAcesso_container__zT+6s","content":"LinkAcesso_content__hiCxN","icon":"LinkAcesso_icon__Ems08","message":"LinkAcesso_message__6ZT3d"};